<div class="card">
  <div class="card-body p-0">
    <div class="filter-form">
      <ng-content></ng-content>
      <div class="row">
        <div class="filter-lg-flex filter-lg-none col-12">
          <div class="flex-gap-5" [ngClass]="{ invisible: !(filters() && entity()), 'me-auto': !isInProducts() }">
            @if (isExportButtonShown()) {
              <modal-export-create
                [filters]="filtersForExport()"
                [entity]="entity()"
                [totalItems]="totalItems()"
                (onResult)="triggerExportResult($event); onCreateModalHidden.emit(null)"
              ></modal-export-create>
            }
            @if (isInProducts()) {
              <modal-bulk-edits
                [checkedProducts]="checkedProducts()()"
                [allProductsSelected]="areAllProductsChecked()()"
                [filters]="filters()"
                [tags]="tags()"
                [depots]="depots()"
                (refreshProductsPage)="refreshProduct()"
                (setCheckedProductsToFalse)="setCheckedProductsToFalseMethod()"
                [dataCyAttribute]="'bulk-edit-modal-products'"
              >
              </modal-bulk-edits>
            }
            @if (isInOrders()) {
              <modal-bulk-edits-orders
                [checkedOrders]="checkedOrders()"
                [allOrdersSelected]="areAllOrdersChecked()"
                [filters]="filters()"
                [tags]="tags()"
                [payments]="payments()"
                [carriers]="carriers()"
                [checkedMap]="checkedMap()"
                [isShowingTags]="isShowingTags()"
                (refreshOrdersPage)="refreshOrder()"
                (setCheckedOrdersToFalse)="setCheckedOrdersToFalseMethod()"
                [dataCyAttribute]="'bulk-edit-modal-orders'"
              >
              </modal-bulk-edits-orders>
            }
            @if (isInOrders()) {
              <button
                class="btn-third me-2 float-right dropdown-toggle"
                id="dropdownMenu2"
                data-bs-toggle="dropdown"
                data-cy="download-receipt-dropdown"
              >
                {{ 'order.print-and-download' | translate }}
              </button>
            }
            <div class="dropdown-menu margin-right-150" aria-labelledby="dropdownMenu2">
              <button
                class="dropdown-item"
                type="button"
                data-cy="download-orders-reservation"
                (click)="downloadInvoicesForSelectedOrders('orders-reservation')"
              >
                {{ 'order' | translate }}
              </button>
              <button
                class="dropdown-item"
                type="button"
                data-cy="download-orders-invoice"
                (click)="downloadInvoicesForSelectedOrders('orders-invoice')"
              >
                {{ 'invoice' | translate }}
              </button>
              <button
                class="dropdown-item"
                type="button"
                data-cy="download-orders-picking-list"
                (click)="downloadInvoicesForSelectedOrders('orders-picking-list')"
              >
                {{ 'download.pdf-pickingList' | translate }}
              </button>
              <button
                class="dropdown-item"
                type="button"
                data-cy="download-orders-delivery-note"
                (click)="downloadInvoicesForSelectedOrders('orders-delivery-note')"
              >
                {{ 'download.pdf-deliveryNote' | translate }}
              </button>
            </div>
            @if (areExportsInFilter()) {
              <app-exports #exportsModal [entity]="entity()"></app-exports>
            }
            @if (isInProducts() && isPurchaseOrderShown()) {
              <btn
                [label]="'products.purchase-orders.stocking-orders'"
                [title]="'products.purchase-orders.stocking-orders' | translate"
                [classes]="['btn-third', 'float-right', 'me-2']"
                [icon]="''"
                [btnType]="'button'"
                [dataCyAttribute]="'create-purchase-orders-button'"
                (click)="checkIfAtLeastOneItemIsSelected()"
              >
              </btn>
            }
            @if (totalItems() > 0) {
              <div class="d-flex align-items-center font-size-14">
                {{ ('record.amount' | translate) + (totalItems() | number: '1.0-2' | replaceCommaToDot) }}
              </div>
            }
          </div>
          <div
            class="rolling-content-btn align-self-center"
            (click)="triggerOnVisibilityChange()"
            [ngClass]="{ invisible: isFilterInvisible(), 'margin-0-auto': isInProducts() }"
            data-cy="rolling-filters-btn"
          >
            <div class="flex-gap-5 align-items-center">
              <i [ngClass]="{ rotate: filterVisible()() }" class="fa fa-chevron-down" data-cy="filter"></i>
              <div>
                {{ (filterVisible()() ? 'filters.hide' : 'filters.show') | translate }}
              </div>
            </div>
          </div>
          <div class="flex-gap-5 flex-row-reverse ms-auto">
            <btn
              [btnType]="'submit'"
              [icon]="'far-search'"
              (onEvent)="triggerOnSubmit()"
              [label]="'filter'"
              [classes]="['btn-first']"
              [dataCyAttribute]="'submit-filter'"
              [title]="'filter' | translate"
            ></btn>
            <btn
              [btnType]="'button'"
              [icon]="'far-times'"
              (onEvent)="triggerOnClear()"
              [label]="'clear'"
              [classes]="['btn-third']"
              [dataCyAttribute]="'cancel-filter'"
              [title]="'clear' | translate"
            ></btn>
          </div>
        </div>

        <div class="filter-md-flex filter-md-none col-12 filter-responsive">
          <div
            class="rolling-content-btn align-self-center"
            (click)="triggerOnVisibilityChange()"
            (keyup)="triggerOnVisibilityChange()"
            [ngClass]="{ invisible: isFilterInvisible() }"
            role="button"
            tabIndex="0"
            aria-disabled="true"
            data-cy="mobile-rolling-filters-btn"
          >
            <div class="flex-gap-5 align-items-center">
              <i [ngClass]="{ rotate: filterVisible()() }" class="fa fa-chevron-down" data-cy="filter"></i>
              <div>
                {{ (filterVisible()() ? 'filters.hide' : 'filters.show') | translate }}
              </div>
            </div>
          </div>
          <div class="flex-gap-5 flex-row-reverse">
            <btn
              [btnType]="'submit'"
              [icon]="'far-search'"
              (onEvent)="triggerOnSubmit()"
              [label]="'filter'"
              [title]="'filter' | translate"
              [classes]="['btn-first']"
              [dataCyAttribute]="'mobile-submit-filter'"
            ></btn>
            <btn
              [btnType]="'button'"
              [icon]="'far-times'"
              (onEvent)="triggerOnClear()"
              [label]="'clear'"
              [title]="'clear' | translate"
              [classes]="['btn-third']"
              [dataCyAttribute]="'mobile-cancel-filter'"
            ></btn>
            <modal-export-create
              [filters]="filters()"
              [entity]="entity()"
              [totalItems]="totalItems()"
              (onResult)="triggerExportResult($event); onCreateModalHidden.emit(null)"
            ></modal-export-create>
            @if (areExportsInFilter()) {
              <app-exports #exportsModal [entity]="entity()"></app-exports>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
